import { z } from 'zod';

import { pushPayloadSchema } from '../api/schemas';
import { SEVERITIES } from '../types/domain.types';

export const WORKER_MESSAGE = {
  alert: 'ctl-alert',
  click: 'ctl-notification-click',
  subscriptionChanged: 'ctl-subscription-changed',
} as const;

const workerMessageSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal(WORKER_MESSAGE.alert), payload: pushPayloadSchema.nullable().catch(null) }),
  z.object({
    type: z.literal(WORKER_MESSAGE.click),
    action: z.enum(['start', 'open']),
    link: z.string().min(1),
    issueId: z.string().nullable().default(null),
    severity: z.enum(SEVERITIES).nullable().default(null).catch(null),
  }),
  z.object({ type: z.literal(WORKER_MESSAGE.subscriptionChanged) }),
]);

export type WorkerMessage = z.infer<typeof workerMessageSchema>;

export const workerMessageOf = (data: unknown): WorkerMessage | null => {
  const parsed = workerMessageSchema.safeParse(data);
  return parsed.success ? parsed.data : null;
};
